import axios from 'axios';
import auth from '../utils/auth';

const {
    [process.env.NODE_ENV]: REQUEST_TIMEOUT
} = {
    development: 60000,
    production: 3000,
};
const UNAUTHORIZED_ROUTE_NAME = 'IndexVideo';
// axios.defaults.withCredentials = false;
const $axios = axios.create({});
const $http = axios.create({
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': auth.getUserInfo().user_token
    }
});
const $httpnoauth = axios.create({
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': "admin"
    }
});

function routeRedirect(router) {
    if (UNAUTHORIZED_ROUTE_NAME !== router.currentRoute.name) {
        auth.removeToken();
        auth.removeUserInfo();
        router.replace({
            name: UNAUTHORIZED_ROUTE_NAME,
        });
    }
}

export default {
    install(Vue, { router, store }) {
        // 需要认证的接口（自动跳转或添加认证token）
        const requestInterceptor = (config) => {


            // console.log(config.headers)
            var headers = {
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': auth.getUserInfo().user_token
            };
            console.log(auth.getUserInfo().user_token)
                // console.log(auth.getUserInfo().user_token)
            const conf = config;
            // const token = auth.getUserInfo().user_token;
            // conf.headers.token = `${token}`;

            // conf.headers.Authorization = auth.getUserInfo().user_token;
            conf.headers = headers

            return conf;
        };
        const noAuthRequestInterceptor = (config) => {

            var headers = {
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': "admin"
            };
            const conf = config;

            conf.headers = headers
            return conf;
        };

        const responseInterceptor = (response) => {

            // console.log(1111111111111111111111111)
            // console.log(response)

            // eslint-disable-next-line eqeqeq
            if (response.data.err_code == -1) {
                store.dispatch('loginOut', {});
                auth.removeToken();
                auth.removeUserInfo();
                routeRedirect(router);

            }
            return response;
        };

        const errorHandler = (error) => {
            // console.log(66666666)

            if (error.response.status == 401) {
                console.log(error)

                console.log('not auth')
                store.dispatch('loginOut', {});
                auth.removeToken();
                auth.removeUserInfo();
                routeRedirect(router);
                throw new Error('登录超时请重新登录');
            }

            console.log(error)
            store.dispatch('stopLoading');
            const { response: { data } = {}, request } = error;
            const { status } = data || request || {};

            if (status === 401) {


                routeRedirect(router);
            }
            if (error.response) {
                return Promise.reject(error.response.data);
            }
            if (error.request) {
                return Promise.reject(error.request);
            }
            return Promise.reject(error);
        };

        $httpnoauth.interceptors.request.use(noAuthRequestInterceptor, errorHandler);
        $http.interceptors.request.use(requestInterceptor, errorHandler);
        $http.interceptors.response.use(responseInterceptor, errorHandler);
        $axios.interceptors.response.use(responseInterceptor, errorHandler);

        // Vue.axios用于请求那些不需要登录认证的接口

        Vue.axios = $axios;
        // Vue.http用于请求需要登录认证的接口

        Vue.http = $http;
        Vue.httpnoauth = $httpnoauth;
    },
};